(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function post(url, body) {
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
          return j;
        });
      });
    }

    function getCart(root) {
      return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    function setBubble(count) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
        el.textContent = count < 100 ? String(count) : '';
        el.classList.toggle('hidden', count === 0);
      });
      document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', count === 0); });
    }

    function busy(root, on) {
      if (on) root.setAttribute('aria-busy', 'true'); else root.removeAttribute('aria-busy');
    }

    function showError(root) {
      var el = root.querySelector('[data-dt-cart-error]');
      if (el) { el.hidden = false; el.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }

    // Fetch the section again and swap only the parts that change, so the
    // checkout button and any express buttons are never rebuilt.
    function refresh(root) {
      return fetch(root.dataset.cartUrl + '?section_id=' + encodeURIComponent(root.dataset.sectionId), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-dt-cart]');
          if (!fresh || fresh.querySelector('[data-dt-cart-empty]')) { window.location.reload(); return; }
          root.dataset.orphans = fresh.dataset.orphans || '';
          fresh.querySelectorAll('[data-swap]').forEach(function (next) {
            var now = root.querySelector('[data-swap="' + next.dataset.swap + '"]');
            if (!now) return;
            if (now.tagName === 'DETAILS' && now.open) next.setAttribute('open', '');
            now.replaceWith(next);
          });
          if (root.dataset.pendingDiscountError) {
            delete root.dataset.pendingDiscountError;
            var el = root.querySelector('[data-dt-cart-discount-error]');
            if (el) { el.textContent = root.dataset.discountError; el.hidden = false; }
          }
          return getCart(root).then(function (cart) { setBubble(cart.item_count); });
        });
    }

    // Removing an add-on: put the desk's own line back to "none" for that choice first
    function removeLine(root, key) {
      return getCart(root).then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        var p = line.properties || {};
        var desk = p._build && p._desk_prop
          ? cart.items.filter(function (i) { return i.properties && i.properties._build === p._build && i.properties._Droptop; })[0]
          : null;

        var step = Promise.resolve();
        if (desk) {
          var props = {};
          Object.keys(desk.properties).forEach(function (k) { props[k] = desk.properties[k]; });
          if (p._desk_none) props[p._desk_prop] = p._desk_none; else delete props[p._desk_prop];
          if (p._desk_hidden) delete props[p._desk_hidden];
          // The desk's picture showed this add-on: swap in the one taken without it
          if (p._desk_pic && props[p._desk_pic]) { props._Snapshot = props[p._desk_pic]; delete props[p._desk_pic]; }
          step = post(root.dataset.changeUrl, { id: desk.key, quantity: desk.quantity, properties: props });
        }
        return step.then(function () { return post(root.dataset.changeUrl, { id: key, quantity: 0 }); });
      });
    }

    // Removing a desk takes every line of its build with it, in one request
    function removeBuild(root, build, deskKey) {
      return getCart(root).then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) {
          if (i.key === deskKey || (build && i.properties && i.properties._build === build)) updates[i.key] = 0;
        });
        return post(root.dataset.updateUrl, { updates: updates });
      });
    }

    function run(root, work) {
      busy(root, true);
      return work()
        .then(function () { return refresh(root); })
        .catch(function () { showError(root); })
        .then(function () { busy(root, false); });
    }

    function codesNow(root) {
      return Array.prototype.map.call(root.querySelectorAll('[data-discount-code]'), function (li) { return li.dataset.discountCode; });
    }

    function watchSticky(root) {
      var bar = root.querySelector('[data-dt-cart-sticky]');
      var button = root.querySelector('#dt-cart-checkout');
      if (!bar || !button || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Only while the real button is still BELOW the screen — never once it has been passed
        bar.hidden = e.isIntersecting || e.boundingClientRect.top < 0;
      }).observe(button);
    }

    function init(root) {
      if (root.dataset.dtCartReady) return;
      root.dataset.dtCartReady = 'true';

      root.addEventListener('click', function (ev) {
        var t = ev.target.closest('[data-dt-cart-ask], [data-dt-cart-keep], [data-dt-cart-remove], [data-dt-cart-discount-remove]');
        if (!t || !root.contains(t)) return;

        if (t.hasAttribute('data-dt-cart-ask')) {
          var panel = t.parentNode.querySelector('[data-dt-cart-confirm]');
          panel.hidden = false;
          t.setAttribute('aria-expanded', 'true');
          var yes = panel.querySelector('[data-dt-cart-remove]');
          if (yes) yes.focus();
          return;
        }
        if (t.hasAttribute('data-dt-cart-keep')) {
          var wrap = t.closest('[data-dt-cart-confirm]');
          wrap.hidden = true;
          var ask = wrap.parentNode.querySelector('[data-dt-cart-ask]');
          if (ask) { ask.setAttribute('aria-expanded', 'false'); ask.focus(); }
          return;
        }
        if (t.hasAttribute('data-dt-cart-discount-remove')) {
          var gone = t.closest('[data-discount-code]').dataset.discountCode;
          var left = codesNow(root).filter(function (c) { return c !== gone; });
          run(root, function () { return post(root.dataset.updateUrl, { discount: left.join(',') }); });
          return;
        }
        if (t.dataset.dtCartRemove === 'build') {
          run(root, function () { return removeBuild(root, t.dataset.build, t.dataset.lineKey); });
        } else {
          run(root, function () { return removeLine(root, t.dataset.lineKey); });
        }
      });

      root.addEventListener('submit', function (ev) {
        var form = ev.target.closest('[data-dt-cart-discount-form]');
        if (!form) return;
        ev.preventDefault();
        var input = form.querySelector('input[name="discount"]');
        var code = (input.value || '').trim();
        if (!code) return;
        var before = codesNow(root);
        var errorEl = root.querySelector('[data-dt-cart-discount-error]');
        if (errorEl) errorEl.hidden = true;
        run(root, function () {
          return post(root.dataset.updateUrl, { discount: before.concat([code]).join(',') }).then(function (cart) {
            var mine = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
            if (mine && mine.applicable) return;
            // Not valid for this cart: take it back off and say so
            root.dataset.pendingDiscountError = '1';
            return post(root.dataset.updateUrl, { discount: before.join(',') });
          });
        });
      });

      var noteTimer;
      root.addEventListener('input', function (ev) {
        if (!ev.target.matches('[data-dt-cart-note]')) return;
        window.clearTimeout(noteTimer);
        var value = ev.target.value;
        noteTimer = window.setTimeout(function () { post(root.dataset.updateUrl, { note: value }).catch(function () {}); }, 600);
      });

      watchSticky(root);

      // An add-on whose desk has gone does not belong in the cart
      var orphans = (root.dataset.orphans || '').split(',').filter(Boolean);
      if (orphans.length) {
        var updates = {};
        orphans.forEach(function (k) { updates[k] = 0; });
        run(root, function () { return post(root.dataset.updateUrl, { updates: updates }); });
      }
    }

    function boot() { document.querySelectorAll('[data-dt-cart]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-option-cards"] && !Shopify.designMode) return;
  try {
    
  /* A carousel inside a closed drop-down measures 0 wide when the page
     loads, which leaves its "next" arrow switched off. Re-check the arrows
     whenever a drop-down opens. */
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el || !el.querySelectorAll) return;
    el.querySelectorAll('.dt-oc--carousel .dt-swipe__track, .dt-swipe__track').forEach(function (track) {
      track.dispatchEvent(new Event('scroll'));
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
